var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Base64 } from 'js-base64';
import { PaymentValidationError, PaymentErrorShortCodes } from '../..';
import { PaymentAdapterIngenico } from '../../Adapters';
import { PaymentVendors } from '../../Interfaces/interface.adapter';
import { LegacyConfig } from '../Configs/config.legacy.api';
import { PaymentLegacyEncryptor } from '../Encryption/PaymentLegacyEncryptor';
import { PaymentLegacyCommunicator } from './PaymentLegacyCommunicator';
var LegacyPaymentMethod;
(function (LegacyPaymentMethod) {
    LegacyPaymentMethod["creditCard"] = "CC";
    LegacyPaymentMethod["eCheck"] = "ECHECK";
    LegacyPaymentMethod["ACH"] = "DD";
    LegacyPaymentMethod["ePaperToken"] = "EPAPERTOKEN";
})(LegacyPaymentMethod || (LegacyPaymentMethod = {}));
var PaymentLegacySession = /** @class */ (function () {
    function PaymentLegacySession(env, sessionId, sessionData) {
        this.env = env;
        this.securityToken = PaymentLegacySession.formatSecurityToken(sessionId);
        this.sessionData = sessionData;
        this.sessionData.appName = PaymentLegacySession.formatAppName(this.sessionData.appName);
        this.sessionData.currency = PaymentLegacySession.formatCurrency(this.sessionData.currency);
        this.paymentCommunicator = new PaymentLegacyCommunicator(env);
    }
    PaymentLegacySession.formatSecurityToken = function (securityToken) {
        PaymentLegacySession.isValidSecurityToken(securityToken);
        return securityToken;
    };
    PaymentLegacySession.isValidSecurityToken = function (securityToken) {
        if (!/^[SV][a-zA-Z0-9]{32}$/.test(securityToken)) {
            throw new PaymentValidationError('Security token contains illegal characters or has illegal format', PaymentErrorShortCodes.invalid_session);
        }
        return true;
    };
    PaymentLegacySession.formatAppName = function (appName) {
        PaymentLegacySession.isValidAppName(appName);
        return appName;
    };
    PaymentLegacySession.isValidAppName = function (appName) {
        if (appName.length === 0) {
            throw new PaymentValidationError('Application Name contains illegal characters or has illegal format', PaymentErrorShortCodes.invalid_app_name);
        }
        return true;
    };
    PaymentLegacySession.formatCurrency = function (currency) {
        PaymentLegacySession.isValidCurrency(currency);
        return currency;
    };
    PaymentLegacySession.isValidCurrency = function (currency) {
        if (!/^[a-zA-Z]{1,3}$/.test(currency)) {
            throw new PaymentValidationError('Currency contains illegal characters or has illegal format', PaymentErrorShortCodes.invalid_currency);
        }
        return true;
    };
    PaymentLegacySession.isValidRSAPublicKey = function (publicKey) {
        if (!/^[a-zA-Z0-9]{1,512}$/.test(publicKey)) {
            throw new PaymentValidationError('Encryption Key contains illegal characters or has illegal format', PaymentErrorShortCodes.invalid_encryption_key);
        }
        return true;
    };
    PaymentLegacySession.isValidVendorSessionToken = function (sessionToken) {
        if (sessionToken.vendorName !== PaymentVendors.ingenico || !sessionToken.token || !sessionToken.publicKey) {
            throw new PaymentValidationError('Encryption Key has illegal format', PaymentErrorShortCodes.invalid_encryption_key);
        }
        return true;
    };
    PaymentLegacySession.prototype.encryptLegacyCreditCard = function (creditCard, billingContact, threeDSInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var legacyEncryptor, encodedSessionToken, encodedToken, decodedToken, sessionToken, encryptedCard;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        legacyEncryptor = new PaymentLegacyEncryptor();
                        try {
                            encodedToken = JSON.parse(this.sessionData.encryptionKey);
                            encodedSessionToken = encodedToken.sessionToken;
                            decodedToken = Base64.decode(encodedSessionToken);
                            sessionToken = JSON.parse(decodedToken);
                            PaymentLegacySession.isValidVendorSessionToken(sessionToken);
                        }
                        catch (e) {
                            throw new PaymentValidationError('Encryption Key has illegal format', PaymentErrorShortCodes.invalid_encryption_key, {
                                cause: {
                                    message: e.message,
                                    details: JSON.stringify(e)
                                }
                            });
                        }
                        return [4 /*yield*/, legacyEncryptor.ingenicoEncryptCreditCardInfo(this.env, encodedSessionToken, creditCard, billingContact)];
                    case 1:
                        encryptedCard = _a.sent();
                        return [4 /*yield*/, this.getCreditCardParams(creditCard, billingContact, encryptedCard, threeDSInfo)];
                    case 2: 
                    // Prepare PaymentRequest
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PaymentLegacySession.prototype.getCreditCardParams = function (creditCard, billingContact, encryptedCard, threeDSInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var onPremPaymentProductId, billingMethodParams, payment, paymentData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        onPremPaymentProductId = PaymentAdapterIngenico.getOnPremPaymentProductId(creditCard.number);
                        billingMethodParams = {
                            exp_month: creditCard.expiration.month,
                            exp_year: creditCard.expiration.year,
                            paymentProductId: onPremPaymentProductId.toString(),
                            cardBin: creditCard.number.slice(0, 6),
                            cardSummary: creditCard.number.slice(-4)
                        };
                        return [4 /*yield*/, this.paymentCommunicator.getPaymentRequest(this.securityToken, LegacyPaymentMethod.creditCard, encryptedCard, this.sessionData.appName, billingContact, threeDSInfo, billingMethodParams)];
                    case 1:
                        payment = _a.sent();
                        paymentData = JSON.stringify(payment);
                        this.encryptedPaymentData = paymentData;
                        return [2 /*return*/, paymentData];
                }
            });
        });
    };
    PaymentLegacySession.prototype.encryptLegacyACH = function (achInfo, billingContact) {
        return __awaiter(this, void 0, void 0, function () {
            var legacyEncryptor, encryptedACHData, payment, paymentData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sessionData.encryptionKey = LegacyConfig.getDefaultRSAPublicKey(this.env);
                        legacyEncryptor = new PaymentLegacyEncryptor();
                        return [4 /*yield*/, legacyEncryptor.rsaEncryptACHInfo(this.sessionData.encryptionKey, achInfo)];
                    case 1:
                        encryptedACHData = _a.sent();
                        return [4 /*yield*/, this.paymentCommunicator.getPaymentRequest(this.securityToken, LegacyPaymentMethod.ACH, encryptedACHData, this.sessionData.appName, billingContact)];
                    case 2:
                        payment = _a.sent();
                        paymentData = JSON.stringify(payment);
                        this.encryptedPaymentData = paymentData;
                        return [2 /*return*/, paymentData];
                }
            });
        });
    };
    PaymentLegacySession.prototype.encryptLegacyECheck = function (eCheckInfo, billingContact) {
        return __awaiter(this, void 0, void 0, function () {
            var legacyEncryptor, encryptedECheckData, paymentRequest, paymentData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sessionData.encryptionKey = LegacyConfig.getDefaultRSAPublicKey(this.env);
                        legacyEncryptor = new PaymentLegacyEncryptor();
                        return [4 /*yield*/, legacyEncryptor.rsaEncryptECheckInfo(this.sessionData.encryptionKey, eCheckInfo)];
                    case 1:
                        encryptedECheckData = _a.sent();
                        return [4 /*yield*/, this.paymentCommunicator.getPaymentRequest(this.securityToken, LegacyPaymentMethod.eCheck, encryptedECheckData, this.sessionData.appName, billingContact)];
                    case 2:
                        paymentRequest = _a.sent();
                        paymentData = JSON.stringify(paymentRequest);
                        this.encryptedPaymentData = paymentData;
                        return [2 /*return*/, paymentData];
                }
            });
        });
    };
    PaymentLegacySession.prototype.encryptLegacyEPaperToken = function (ePaperTokenInfo, billingContact) {
        return __awaiter(this, void 0, void 0, function () {
            var legacyEncryptor, encryptedEPaperTokenData, billingMethodParams, paymentRequest, paymentData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sessionData.encryptionKey = LegacyConfig.getDefaultRSAPublicKey(this.env);
                        legacyEncryptor = new PaymentLegacyEncryptor();
                        return [4 /*yield*/, legacyEncryptor.rsaEncryptEPaperTokenInfo(this.sessionData.encryptionKey, ePaperTokenInfo)];
                    case 1:
                        encryptedEPaperTokenData = _a.sent();
                        billingMethodParams = {
                            exp_month: ePaperTokenInfo.expiration.month,
                            exp_year: ePaperTokenInfo.expiration.year
                        };
                        return [4 /*yield*/, this.paymentCommunicator.getPaymentRequest(this.securityToken, LegacyPaymentMethod.ePaperToken, encryptedEPaperTokenData, this.sessionData.appName, billingContact, undefined, billingMethodParams)];
                    case 2:
                        paymentRequest = _a.sent();
                        paymentData = JSON.stringify(paymentRequest);
                        this.encryptedPaymentData = paymentData;
                        return [2 /*return*/, paymentData];
                }
            });
        });
    };
    PaymentLegacySession.prototype.processLegacyPayment = function (paymentRequest) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.paymentCommunicator.processLegacyPayment(paymentRequest)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return PaymentLegacySession;
}());
export { PaymentLegacySession };
